import { V3Models } from "@istari/istari-client";

import { ResourceType } from "~/resource/model/resource-type";

export function toResourceType(resourceType: V3Models.ResourceTypeDto | string): ResourceType {
  switch (resourceType) {
    case V3Models.ResourceTypeDto.Model:
      return ResourceType.Model;
    case V3Models.ResourceTypeDto.Artifact:
      return ResourceType.Artifact;
    case V3Models.ResourceTypeDto.File:
      return ResourceType.File;
    default:
      return ResourceType.File;
  }
}
